/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import BlogToolBar from 'components/BlogToolBar';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AppStyle from 'scss/main/App.module.scss';
import { useGetBlogQuery, usePostCommentMutation, useSubmitLikesMutation } from 'services/blog.sevices';
import { decodeHtml, decodeHtmlContent } from 'utils';
import Comment from 'components/Comment';
import CommentBox from 'components/CommentBox';
import { useDispatch } from 'react-redux';
import { Action } from 'store/slices';
import { Tooltip } from 'react-tooltip'

let isCommendFirstLoaded = false;
const Blog: React.FC<{}> = ({

}) => {

  let { id } = useParams();
  const dispatch = useDispatch();
  const { data, refetch, isSuccess: isSuccessFetch } = useGetBlogQuery({ id: id ?? 0 }, {
    refetchOnMountOrArgChange: true
  });
  const [postComment, { isLoading, isSuccess }] = usePostCommentMutation()
  const [submitLikes] = useSubmitLikesMutation()

  document.title = data?.success ? `${data?.title} - Sam Tsang` : `Blog - Sam Tsang`

  const [currentLikes, setLikes] = useState(data?.likes ?? 0);

  useEffect(() => {
    if (isSuccessFetch) {
      setLikes(data?.likes)
    }
  }, [isSuccessFetch])

  useEffect(() => {
    if (isLoading) {
      isCommendFirstLoaded = true;
    }
    if (!isLoading && isSuccess) {
      refetch();
      dispatch(Action.toggleDialog({type: 'success', msg: 'Comment submitted!'}))
    } else if (isCommendFirstLoaded && !isSuccess) {
      dispatch(Action.toggleDialog({type: 'alery', msg: 'Something went wrong!'}))
    }
  }, [isLoading])

  const putLikes = () => {
    submitLikes({aid: id ?? 0});
    setLikes(currentLikes + 1)
  }

  return data?.success ? (
    <div className={AppStyle['blog-content']}>
      <div>
        <div>
          <div><img src={data?.cover} /></div>
          <div>{data?.title}</div>
        </div>
        <div>
          {data?.avatar ? <div style={{ backgroundImage: `url('${data?.avatar}')`}} /> : <div><div>{data?.display_name.charAt(0)}</div></div>}
          <div>
            <div>{data?.display_name}</div>
            <Tooltip id='blog-content-datetime' />
            <div data-tooltip-id='blog-content-datetime' data-tooltip-place='top-end' data-tooltip-content={moment((data?.created_time ?? 0) * 1000).format('MMM Do YYYY')}>{data?.promote} - {moment((data?.created_time ?? 0) * 1000).fromNow()}</div>
          </div>
        </div>
        <BlogToolBar starCount={currentLikes} commentCount={data?.comments?.length ?? 0} share={{
          aid: data?.aid,
          title: data?.title,
          desc: `${decodeHtmlContent(data?.content ?? '11').split(' ', 50).join(' ')}...`
        }} putLikes={putLikes} />
        <div dangerouslySetInnerHTML={{ __html: decodeHtml(data?.content ?? '') }} />
        <div>
          Disclaimer: The content provided on this blog (samjay.dev) is intended for informational and educational purposes only. Readers are welcome to share and copy the content, provided they attribute the source by mentioning the original author and source link. However, any modification of the content is strictly prohibited. The views and opinions expressed in the articles are those of the respective authors and do not necessarily reflect the official policy or position of the website owner. We do not take responsibility for any actions or consequences resulting from the use of the information presented on this website. Readers are encouraged to independently verify information and seek professional advice if necessary. By accessing and using this website, you agree to abide by these terms and conditions.
        </div>
        <BlogToolBar starCount={currentLikes} commentCount={data?.comments?.length ?? 0} share={{
          aid: data?.aid,
          title: data?.title,
          desc: `${decodeHtmlContent(data?.content ?? '11').split(' ', 50).join(' ')}...`
        }} putLikes={putLikes} />
        <div id='comment'>
          <div>
            Leave a Comment
          </div>
          <CommentBox aid={data?.aid} post={(aid, name, email, comment) => postComment({aid, name, email, comment})} isLoading={isLoading} isSuccess={isSuccess} />
          <div>
            Responses ({data?.comments.length})
          </div>
          <div>
            {(data?.comments?.length ?? 0) > 0 ? data?.comments?.map(d => <Comment cid={d.cid} uid={d.uid} avatar={d.avatar} display_name={d.display_name} comment={d.comment} created_time={d.created_time} updated_time={d.updated_time} />)
              : <noindex>
                <div>There are currently no responses for this story.</div>
                <div>Be the first to respond.</div>
            </noindex>}
          </div>
        </div>
      </div>
    </div>
  ) : <div className={AppStyle['blog-content']} />;
}

export default Blog;